/**
 * SORGU ANAHTARI FABRIKASI — profil.
 *
 * GECERSIZ KILMA HARITASI:
 *   updateSelf (sifresiz)  -> self()   ve oturum ozeti (session.store.revalidate)
 *   updateSelf (sifreli)   -> gecersiz kilmak GEREKMEZ: sunucu tum oturumlari
 *                             dusuruyor, kullanici cikis yapiyor ve onbellek
 *                             tam sayfa gezinmeyle zaten sifirlaniyor.
 *   deleteSelf             -> ayni sebeple; hesap artik yok.
 */
export const profileKeys = {
  all: ['profile'] as const,
  /** GET /v1/users — SELF; sunucu cagiranin kendi satirina kilitler. */
  self: () => [...profileKeys.all, 'self'] as const,
};
